import { useCart as useShopwareCart, useCartFunction } from "@shopware-pwa/composables-next";

export function useCart() {
let refreshCart, isEmpty, cart, totalPrice, addProduct, addProducts, addPromotionCode, appliedPromotionCodes, cartItems, changeProductQuantity, count, removeItem, shippingTotal, subtotal, isVirtualCart, consumeCartErrors;

if (import.meta.server) {
  ({
    refreshCart,
    isEmpty,
    cart,
    totalPrice,
    addProduct,
    addProducts,
    addPromotionCode,
    appliedPromotionCodes,
    cartItems,
    changeProductQuantity,
    count,
    removeItem,
    shippingTotal,
    subtotal,
    isVirtualCart,
    consumeCartErrors,
  } = useCartFunction());
} else {
  ({
    refreshCart,
    isEmpty,
    cart,
    totalPrice,
    addProduct,
    addProducts,
    addPromotionCode,
    appliedPromotionCodes,
    cartItems,
    changeProductQuantity,
    count,
    removeItem,
    shippingTotal,
    subtotal,
    isVirtualCart,
    consumeCartErrors,
  } = useShopwareCart());
}

  return {
    addProduct,
    addProducts,
    addPromotionCode,
    appliedPromotionCodes,
    cart,
    cartItems,
    changeProductQuantity,
    count,
    refreshCart,
    removeItem,
    totalPrice,
    shippingTotal,
    subtotal,
    isEmpty,
    isVirtualCart,
    consumeCartErrors,
  };
}

